import { render, staticRenderFns } from "./StudentsExercises.vue?vue&type=template&id=57d7af22&scoped=true&"
import script from "./StudentsExercises.vue?vue&type=script&lang=js&"
export * from "./StudentsExercises.vue?vue&type=script&lang=js&"
import style0 from "./StudentsExercises.vue?vue&type=style&index=0&id=57d7af22&scoped=true&lang=css&"
import style1 from "./StudentsExercises.vue?vue&type=style&index=1&id=57d7af22&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d7af22",
  null
  
)

export default component.exports